import React from 'react'

import './CardContent.css'

const CardContent = ({ children }) => {

    return (<div className='card-content'>
        {children}
    </div>)
}

export default CardContent